import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unknownProjectWarning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownProjectWarningGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unknownProjectWarning: {
		id: 'shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning',
		defaultMessage: 'You do not have access to this project. Saving will remove this share.',
		description:
			'Text explaining the "unkown project" share entry and warning that saving it could lose data.',
	},
	unknownProjectWarningGalaxia: {
		id: 'shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning-galaxia',
		defaultMessage: 'You do not have access to this space. Saving will remove this share.',
		description:
			'Text explaining the "unkown project" share entry and warning that saving it could lose data.',
	},
});
export default messages;
